<nav class="navbar">
  <div class="nav-container">
    <div class="half-nav text-overflow">
      <a>
        <img
          src="./assets/RINALogo.png"
          alt="Logo RINA"
          style="display: block; height: 3rem"
        />
      </a>
      <a [routerLink]="homeRoute" class="dx-icon-home"></a>
      @if (!isRcip) {
        <dx-menu
          [dataSource]="reportList"
          [showFirstSubmenuMode]="showSubmenuConfig"
          [hideSubmenuOnMouseLeave]="false"
          displayExpr="name"
          orientation="horizontal"
        >
        </dx-menu>
      }
      <span class="page_title">{{ signalService.titleSignal() }}</span>
    </div>
    <div class="half-nav">
      <!-- Global Search component -->
      @if (!isRcip) {
        <smart-global-search></smart-global-search>
      }
      <!-- Logged user details -->
      <div class="profile-container">
        <span class="material-symbols-outlined"> account_circle </span>
        <div class="profile">
          <div class="username">
            {{ userName }}
          </div>
          <div class="container-second-row">
            <small class="role">{{ userRole }}</small>
            @if (!isRcip && canDelegate(userRole)) {
              <small class="delega" (click)="openDelegateModal()"
                >Delegation</small
              >
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
<dx-load-panel
  [visible]="!!signalService.loadingSignal()"
  [shading]="true"
  shadingColor="'#000000'"
  [showPane]="false"
>
  <dxo-position at="center"></dxo-position>
</dx-load-panel>
<div id="content">
  <router-outlet></router-outlet>
</div>

<!-- Modale Delega -->
<app-modal-delegate
  [isPopupVisible]="isPopupVisible"
  [user]="user()"
  (closeModalEmitter)="onCloseModal($event)"
></app-modal-delegate>
